var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.34024 26.7809C-0.286737 25.8281 -0.0226029 24.5474 0.930198 23.9204L12.7913 16.1154C13.7441 15.4884 15.0248 15.7525 15.6518 16.7053L20.0983 23.4626C20.7253 24.4154 20.4612 25.6961 19.5084 26.3231L7.64721 34.1281C6.69441 34.7551 5.41375 34.491 4.78678 33.5382L0.34024 26.7809Z",
    fill: "#DED2A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.933133 25.3624C0.353779 25.3025 0.16973 24.5488 0.656261 24.2286L13.0647 16.0623C13.5512 15.7421 14.1706 16.2092 13.9965 16.765L11.1289 25.918C11.0408 26.1991 10.767 26.3794 10.4739 26.3491L0.933133 25.3624Z",
    fill: "#A48300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5488 22.5943C18.8016 17.9341 25.0851 12.0589 28.6986 19.9128C29.233 12.2057 37.0168 8.78158 43.7379 9.77384C44.8192 15.9763 42.4372 20.5618 37.7629 24.4019C39.9566 24.4237 44.3645 23.9183 47.6688 21.7154C50.9731 29.4255 28.6348 47.1757 22.2986 25.2276C21.8381 23.7414 19.6572 23.3698 17.647 23.0272C16.8897 22.8981 16.1565 22.7732 15.5488 22.5943Z",
    fill: "#A48300"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3358,
    cy: 19.5128,
    r: 1.10144,
    fill: "#DED2A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.391e173d96ed516fbff908358cbea847.svg";
export { ForwardRef as ReactComponent };